import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterBar = ({ 
  searchTerm, 
  onSearchChange, 
  statusFilter, 
  onStatusChange,
  roleType,
  selectedCount,
  totalCount,
  onSelectAll,
  allSelected 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'Available', label: 'Available' },
    { value: 'On Job', label: 'On Job' },
    { value: 'Off Duty', label: 'Off Duty' }
  ];

  const technicianSkillOptions = [
    { value: 'all', label: 'All Skills' },
    { value: 'HVAC', label: 'HVAC' },
    { value: 'Electrical', label: 'Electrical' },
    { value: 'Plumbing', label: 'Plumbing' },
    { value: 'Appliance Repair', label: 'Appliance Repair' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        {totalCount > 0 && (
          <div className="flex items-center">
            <Checkbox
              checked={allSelected}
              onChange={(e) => onSelectAll?.(e?.target?.checked)}
              label={`Select All (${selectedCount || 0}/${totalCount})`}
            />
          </div>
        )}
        <div className="flex-1">
          <div className="relative">
            <Input
              type="search"
              placeholder="Search by name, email, or phone..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
            />
            <Icon 
              name="Search" 
              size={20} 
              color="var(--color-muted-foreground)" 
              className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
            />
          </div>

          <Select
            label="Filter by Status"
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusChange}
          />

          {roleType === 'technician' && (
            <Select
              label="Filter by Skill"
              options={technicianSkillOptions}
              value="all"
              onChange={() => {}}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;